module.exports = __webpack_public_path__ + "static/media/piso-superior.5ad25487.jpg";